import React, { useMemo } from 'react';

const SkeletonCard = ({length}) => {
  const skeletonItems = useMemo(() => {
    return Array.from({ length }).map((_, index) => (
      <div key={index} className="relative overflow-hidden bg-white px-4 sm:px-10 py-4 sm:py-4 rounded-2xl">
        <div className="flex justify-start items-center animate-pulse">
          <div>
            <div className="rounded-full p-5">
              <div className="h-20 w-20 bg-gray-200 rounded-full dark:bg-gray-700"></div>
            </div>
          </div>
          <dd className="ml-1 w-full">
            <div className="h-4 bg-gray-200 rounded-md dark:bg-gray-700 w-full mb-2"></div>
            <div className="h-6 bg-gray-200 rounded-md dark:bg-gray-700 w-full"></div>
          </dd>
        </div>
      </div>
    ));
  }, []);

  return <>{skeletonItems}</>;
};

export default SkeletonCard;